import React from 'react';
import SelectField from 'components/input/SelectField/SelectField';

const CancelledFilter = <SelectField
    choices={ [
        {
            id: '1',
            name: 'actions.yes',
        },
        {
            id: '0',
            name: 'actions.no',
        },
    ] }
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.cancelled.label'
    source='cancelled'
/>;

export default CancelledFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/CancelledFilter.js